export const TariffTableConfigs = {
  maxRows: 20,
  maxColumns: 3,
  maxRules: 10
};
